import React from "react";
import { useFormatCurrency } from "../common/format-currency";
import styles from "./cart.module.scss";

const cx = (...classNames) => classNames.filter(Boolean).join(" ");

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options); // Format as "17 Aug 2024"
};

const CartItem = ({
  item,
  onIncrease,
  onDecrease,
  isSoldOut,
  isPurchaseDatePassed,
  currency,
  maxTicketPerUser,
}) => {
  const { formatCurrency } = useFormatCurrency();
  const salesEndDate = item.salesEndDate ? formatDate(item.salesEndDate) : null;

  return (
    <div
      className={cx(
        styles.cartItem,
        isSoldOut && styles.soldOut,
        isPurchaseDatePassed && styles.purchaseDatePassed,
      )}
    >
      <div className={styles.cartItemHeader}>
        <h3>{item.name}</h3>
        <div className={styles.quantityControls}>
          <button
            onClick={() => onDecrease(item._id)}
            disabled={
              item.cartQuantity <= 0 || isSoldOut || isPurchaseDatePassed
            }
          >
            -
          </button>
          <span>{item.cartQuantity}</span>
          <button
            onClick={() => onIncrease(item._id)}
            disabled={
              item.cartQuantity >= maxTicketPerUser ||
              isSoldOut ||
              isPurchaseDatePassed
            }
          >
            +
          </button>
        </div>
      </div>
      <p className={styles.cartPrice}>
        {item.amount === 0 ? "Free" : formatCurrency(item.amount, currency)}
      </p>
      {salesEndDate && (
        <p className={styles.salesEndDate}>Sales end on {salesEndDate}</p>
      )}
      {isSoldOut && <p className={styles.statusText}>Sold Out</p>}
      {isPurchaseDatePassed && (
        <p className={styles.statusText}>Purchase Date Passed</p>
      )}
    </div>
  );
};

export default CartItem;
